import { supabase } from "@/integrations/supabase/client";
import { buildImportPhoneVariants } from "@/lib/import-phone";

function samePhone(a: string | null | undefined, b: string | null | undefined): boolean {
  const variants = new Set(buildImportPhoneVariants(a));
  if (variants.size === 0 || !b) return false;
  const other = b.replace(/\D/g, "");
  return variants.has(other) || [...variants].some((v) => v.endsWith(other) || other.endsWith(v));
}

/** Conversa WhatsApp em que o lembrete deste horário deve aparecer. */
export async function resolveAppointmentConversationId(params: {
  workspaceId: string;
  leadId: string;
  phone?: string | null;
  explicitConversationId?: string | null;
  previousAppointmentId?: string | null;
}): Promise<string | null> {
  if (params.explicitConversationId) {
    const { data } = await supabase
      .from("conversations")
      .select("id, channel, lead_id")
      .eq("id", params.explicitConversationId)
      .eq("workspace_id", params.workspaceId)
      .maybeSingle();
    if (data?.channel === "whatsapp" && data.lead_id === params.leadId) return data.id;
  }

  if (params.previousAppointmentId) {
    const { data: previous } = await supabase
      .from("appointments")
      .select("metadata")
      .eq("id", params.previousAppointmentId)
      .eq("workspace_id", params.workspaceId)
      .maybeSingle();
    const previousConversationId = (previous?.metadata as { conversation_id?: string } | null)
      ?.conversation_id;
    if (previousConversationId) {
      const kept = await resolveAppointmentConversationId({
        workspaceId: params.workspaceId,
        leadId: params.leadId,
        explicitConversationId: previousConversationId,
      });
      if (kept) return kept;
    }
  }

  const { data: conversations } = await supabase
    .from("conversations")
    .select("id, external_user_id, is_closed")
    .eq("workspace_id", params.workspaceId)
    .eq("lead_id", params.leadId)
    .eq("channel", "whatsapp");

  const rows = conversations ?? [];
  const openRows = rows.filter((row) => !row.is_closed);
  const pool = openRows.length > 0 ? openRows : rows;
  const matched = pool.filter((row) => samePhone(params.phone, row.external_user_id));
  if (matched.length === 1) return matched[0].id;
  if (matched.length > 1) return matched[0].id;
  if (!params.phone && pool.length === 1) return pool[0].id;
  return null;
}
